import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import Actions from './actions';
import Header from './header';
import Body from './body';
import { isArrayEmpty } from '../../../utility/helpers';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    calendarWrapper: {
      maxWidth: 'fit-content',
    },
    loadMoreWrapper: {
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: spacing(4),
      width: '100%',
    },
    loadMoreWrapperMonth: {
      width: 908,
      maxWidth: 908,
      [breakpoints.up('xLg')]: {
        gridTemplateColumns: 'repeat(auto-fit, 24px)',
        width: 1032,
        maxWidth: 1032,
      },
      [breakpoints.up('xl')]: {
        width: 1203,
        maxWidth: 1203,
      },
    },
    loadMoreButton: {
      border: `1px solid ${primary.bluish3}`,
      borderRadius: 44,
      color: primary.bluish4,
      lineHeight: '24px',
      justifySelf: 'center',
      padding: spacing(1, 4),
      maxHeight: 32,
    },
  })
);

const AbsenceCalendar = ({
  translations,
  calendar,
  absenceReports = [],
  selectedInterval,
  intervalOptions,
  selectedUsersCount = 0,
  hasLoadMore,
  hasDoubleApprove,
  canResolveRequestCheck,
  onLoadMore,
  onResolveRequest,
  canAccessUserProfileCheck,
  onGoToUserProfile,
  onSetCurrentdate,
  onChangeInterval,
  onNextPeriod,
  onPreviousPeriod,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Actions
        translations={translations}
        intervalOptions={intervalOptions}
        selectedInterval={selectedInterval}
        onSetCurrentdate={onSetCurrentdate}
        onChangeInterval={onChangeInterval}
        onNextPeriod={onNextPeriod}
        onPreviousPeriod={onPreviousPeriod}
      />
      <div className={classes.calendarWrapper}>
        {!isArrayEmpty(absenceReports) && (
          <Header
            translations={translations}
            calendar={calendar}
            selectedUsersCount={selectedUsersCount}
          />
        )}
        <Body
          absenceReports={absenceReports}
          calendar={calendar}
          todayPositionIndex={calendar.todayPositionIndex}
          canResolveRequestCheck={canResolveRequestCheck}
          canAccessUserProfileCheck={canAccessUserProfileCheck}
          hasDoubleApprove={hasDoubleApprove}
          onGoToUserProfile={onGoToUserProfile}
          onResolveRequest={onResolveRequest}
        />
        <Fade in={hasLoadMore} unmountOnExit>
          <div
            className={classNames(classes.loadMoreWrapper, {
              [classes.loadMoreWrapperMonth]: calendar.isMonthInterval,
            })}
          >
            <CustomButton
              type="addWithTextRounded"
              className={classes.loadMoreButton}
              onClick={onLoadMore}
            >
              {translations.loadMore}
            </CustomButton>
          </div>
        </Fade>
      </div>
    </div>
  );
};

AbsenceCalendar.propTypes = {
  translations: PropTypes.object.isRequired,
  absenceReports: PropTypes.arrayOf(PropTypes.object),
  selectedUsersCount: PropTypes.number,
  calendar: PropTypes.object.isRequired,
  intervalOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedInterval: PropTypes.string.isRequired,
  hasLoadMore: PropTypes.bool.isRequired,
  hasDoubleApprove: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onGoToUserProfile: PropTypes.func.isRequired,
  canResolveRequestCheck: PropTypes.func.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
  onSetCurrentdate: PropTypes.func.isRequired,
  onChangeInterval: PropTypes.func.isRequired,
  onNextPeriod: PropTypes.func.isRequired,
  onPreviousPeriod: PropTypes.func.isRequired,
};

export default AbsenceCalendar;
